<template>
  <div>
    <OwnerPromtionsView :is_owner_view="false" :is_in_admin_view="true">
    </OwnerPromtionsView>
  </div>
</template>


<script>
import OwnerPromtionsView from "../../business_owner/promotions/OwnerPromtionsView";
import ServerClient from "../../../lib/ServerClient"
import Utils from "../../../lib/Utils"
export default {
  name: "AdminPromotionsView",
  components: {
    OwnerPromtionsView,
  },
  data: function () {
    return {
      promotion_id: 0,
      promotion: Utils.get_default_promotion(),
      is_owner: false,
      _user: null
    }
  },
  mounted() {
    this.promotion_id = parseInt(this.$route.params.id);
    this._user = ServerClient.Login.get_logged_in_user();
    //nyd
    //mak sure that its the admin doing this

    this.$emit("set-page-attributes", {
      title: "View Promotion",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Promotions",
          disabled: false,
          href: "/admin/promotions",
        },
        {
          text: "List",
          disabled: false,
          href: "/admin/promotions/list",
        },
        {
          text: "View",
          disabled: true,
          href: "/admin/promotions/list/view/" + this.promotion_id,
        },
      ],
      navbar_cols: 3,
    });

  },
};
</script>


